import { motion } from "framer-motion";

const PageTransition = ({ children }) => {
  return (
    <motion.div
      className="relative w-full"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.6,
        ease: [0.83, 0, 0.17, 1],
      }}
    >
      {children}

      {/* Fullscreen overlay for fade-to-black */}
      <motion.div
        className="fixed inset-0 bg-black pointer-events-none z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0 }}
        exit={{ opacity: 1 }} // fade in black when leaving
        transition={{ duration: 0.4, ease: "easeInOut" }}
      />
    </motion.div>
  );
};

export default PageTransition;
